/**
 * File is used to add configuration values to window variable.
 * Needs to be imported before something wants to use window values.
 */

declare global {
  interface Window {
    global: Window;
    REACT_APP_ENVIRONMENT: string;
    REACT_APP_SPRENGCONNECT_API: string;
    isSandbox: () => boolean;
    isDevelopment: () => boolean;
    isProduction: () => boolean;
    isStaging: () => boolean;
    isTest: () => boolean;
    isProductionLike: () => boolean;
    fireReporting: () => void;
    VITE_OKTA_CLIENT_ID: string;
    VITE_OKTA_ISSUER: string;
    VITE_OKTA_REDIRECT_URI: string;
    VITE_OKTA_POST_LOGOUT_REDIRECT_URI: string;
    VITE_OKTA_SHOPWARE_IDP_ID: string;
    VITE_SHOPWARE_COINS_URL: string;
    sprengnetter: {
      checkZipCode: (zip: string) => boolean;
    };

    Clerk?: {
      session?: {
        getToken(): Promise<string | null>;
      };
    };
  }
}

window.global = window;
window.REACT_APP_ENVIRONMENT = window.REACT_APP_ENVIRONMENT || "";
window.REACT_APP_SPRENGCONNECT_API = window.REACT_APP_SPRENGCONNECT_API || "";
window.VITE_OKTA_CLIENT_ID = window.VITE_OKTA_CLIENT_ID || "";
window.VITE_OKTA_ISSUER = window.VITE_OKTA_ISSUER || "";
window.VITE_OKTA_REDIRECT_URI = window.VITE_OKTA_REDIRECT_URI || "";
window.VITE_OKTA_POST_LOGOUT_REDIRECT_URI = window.VITE_OKTA_POST_LOGOUT_REDIRECT_URI || "";
window.VITE_OKTA_SHOPWARE_IDP_ID = window.VITE_OKTA_SHOPWARE_IDP_ID || "";
window.VITE_SHOPWARE_COINS_URL = window.VITE_SHOPWARE_COINS_URL || "";
window.isSandbox = (): boolean => window.REACT_APP_ENVIRONMENT?.toLocaleLowerCase() === "sandbox";
window.isDevelopment = (): boolean => window.REACT_APP_ENVIRONMENT?.toLocaleLowerCase() === "development";
window.isProduction = (): boolean => window.REACT_APP_ENVIRONMENT?.toLocaleLowerCase() === "production";
window.isStaging = (): boolean => window.REACT_APP_ENVIRONMENT?.toLocaleLowerCase() === "staging";
window.isTest = (): boolean => window.REACT_APP_ENVIRONMENT?.toLocaleLowerCase() === "test";
window.isProductionLike = (): boolean => window.isProduction() || window.isStaging();
